import React from 'react';
import { iconDescriptionContains } from '../../../util/icons';

export interface DescriptionKeywordsProps {
  descriptionKeywords?: string;
  setSearchOption(key: string, value: string | number): void;
}

export const DescriptionKeywords: React.FC<DescriptionKeywordsProps> = props => {

  return (
    <div className="form-field">
      <div className="form-field-label"><span className="icon">{iconDescriptionContains}</span> Description Contains Keywords</div>
      <input defaultValue={props.descriptionKeywords} onBlur={e => props.setSearchOption('descriptionKeywords', e.target.value)} style={{ width: '100%' }} type="text" name="descriptionKeywords" placeholder="Waterfront, Pool, Fireplace..." />
    </div>
  );
}
